import React, { useState } from "react";
import { FaBars } from "react-icons/fa";
import { GrClose } from "react-icons/gr";
import { Link } from "react-router-dom";
import { logo, logoMobile } from "../../assets";
import Button from "../../shared/buttons";
import { SideBar } from "../sideBar";
import { useStatusBar } from "./hooks/useStatusBar";
import { Container, ContainerBar, ContainerButton } from "./styles";

function Header() {
  const { barStatus, handleOpenBar, handleCloseBar } = useStatusBar();
  const [logoImage, setLogoImage] = useState(
    window.innerWidth <= 768 ? logoMobile : logo
  );

  window.addEventListener("resize", () => {
    if (window.innerWidth <= 768) {
      setLogoImage(logoMobile);
    } else setLogoImage(logo);
  });

  return (
    <>
      <Container>
        {<img src={logoImage} alt="Circuito Incluo LogoTipo" />}
        <nav>
          <ul>
            <li>
              <Link to="/">HOME</Link>
            </li>
            <li>
              <Link to="/about">SOBRE</Link>
            </li>
            <li>
              <Link to="/iniciativas">INICIATIVAS</Link>
            </li>
            <li>
              <Link to="/help">COMO AJUDAR</Link>
            </li>
            <li>
              <Link to="/eventos">EVENTOS</Link>
            </li>
          </ul>
        </nav>
        <ContainerButton>
          <Link to="/doacao"><Button text={"DOAR"} size={"small"} typeButton={"primary"} /></Link>
        </ContainerButton>
        <ContainerBar>
          {barStatus ? (
            <GrClose size={28} className="iconBars" onClick={handleCloseBar} />
          ) : (
            <FaBars size={28} className="iconBars" onClick={handleOpenBar} />
          )}
        </ContainerBar>
      </Container>
      {barStatus ? (
        <ContainerBar>
          <SideBar />
        </ContainerBar>
      ) : null}
    </>
  );
}

export default Header;
